import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Paper from '@material-ui/core/Paper';
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'
const { shahr, ostan } = require('iran-cities-json');

const useStyles = makeStyles(styles);

export default function Profile(props) {
  const { user } = props;
  const classes = useStyles();
  const [state, setState] = React.useState({
    name: user && user.name,
    email: user && user.email,
    city: user && user.city,
    province: user && user.province,
    maritalStatus: user && user.maritalStatus,
    militaryServiceStatus: user && user.militaryServiceStatus,
    nationalCode: user && user.nationalCode,
    title: user && user.title,
    teamName: user && user.teamName,
    gender: user && user.gender,
  });
  var Call = () => {
    if (!validateEmail(state.email)) {
      return swal("ایمیل نادرست است.");
    }
    Axios.post(Config.api + "Authentication/CompleteRegistration", {
      email: state.email,
      city: state.city,
      province: state.province,
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        swal("با موفقیت انجام شد.");
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
        else if (err && err.response && err.response.data && err.response.data.fa_message) {
          swal(err.response.data.fa_message);
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  function vmsNationalCode(input) {
    if (!/^\d{10}$/.test(input)
      || input == '0000000000'
      || input == '1111111111'
      || input == '2222222222'
      || input == '3333333333'
      || input == '4444444444'
      || input == '5555555555'
      || input == '6666666666'
      || input == '7777777777'
      || input == '8888888888'
      || input == '9999999999')
      return false;
    var check = parseInt(input[9]);
    var sum = 0;
    var i;
    for (i = 0; i < 9; ++i) {
      sum += parseInt(input[i]) * (10 - i);
    }
    sum %= 11;
    return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
  }
  const handleDropDownChange = (event) => {
    if (event.target.value == 'true' || event.target.value == 'false')
      setState({ ...state, [event.target.name]: Boolean(event.target.value) });
    else setState({ ...state, [event.target.name]: (event.target.value) });
  };

  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>

          <Paper className={classes.paper} variant="outlined" >
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    اطلاعات تماس
                  </Typography>
                  <div className={classes.formInput}>
                    <TextField disabled id="standard-basic" defaultValue={user && user.phoneNumber} label="شماره موبایل" />
                  </div>
                  <div className={classes.formInput}>
                    <TextField id="standard-basic" defaultValue={user && state.email} name="email" onChange={handleTextBoxChange} label="پست الکترونیک" helperText="مثال: sample@example.com" />
                  </div>

                  <div className={classes.formInput}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="province">استان</InputLabel>
                      <Select
                        onChange={handleDropDownChange}
                        defaultValue={user && state.province}
                        inputProps={{
                          name: 'province',
                          id: 'province',
                        }}
                      >
                        <MenuItem value="">
                          <em>انتخاب کنید</em>
                        </MenuItem>
                        {ostan.map((item, index) => {
                          return (<MenuItem value={item.id}>{item.name}</MenuItem>)
                        })}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.formInput}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="city">شهر</InputLabel>
                      <Select
                        onChange={handleDropDownChange}
                        defaultValue={user && state.city}
                        inputProps={{
                          name: 'city',
                          id: 'city',
                        }}
                      >
                        <MenuItem value="">
                          <em>انتخاب کنید</em>
                        </MenuItem>
                        {shahr.map((item) => {
                          if (item.ostan == state.province)
                            return (<MenuItem value={item.id}>{item.name}</MenuItem>)
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.en + " " + classes.save}>
                  <Button variant="contained" color="primary" disableElevation onClick={Call}>
                    ذخیره سازی
                  </Button>
                </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>
      </GridContainer>
    </form>
  );
}